<template>
    <div class="form-order">
        <b-container fluid>
            <b-row>
                <b-col xl="5" lg="4" class="fixed-div">
                    <b-row class="full-height" >
                        <img src="../../assets/imgs/DDM26-01.jpeg" class="diamedico" alt="">
                    </b-row>
                </b-col>
                <b-col offset-xl="5" xl="7"  offset-lg="4" lg="8" class="order-container">
                    <b-container>
                        <h1 class="mb-5 text-left">{{ dataUser.hospital }}</h1>
                        <b-tabs content-class="mt-5">
                            <b-tab title="REGISTRO NUEVO" active>
                                <b-row :key="checkIfCollaboratorsExist+'_checkIfCollaboratorsExist'">
                                    <b-col cols="12" class="mb-3">
                                        <h3>¡Bienvenido a la plataforma de registro!</h3>
                                    </b-col>
                                    <b-col cols="12" class="mb-3">
                                        <single-select
                                            v-model="dataUser.typeOrder"
                                            :options="listTypeOrder"
                                            placeholder=""
                                            :required="true"
                                            :label="'Selecciona el tipo de orden'"
                                        ></single-select>
                                    </b-col>
                                    <b-col cols="12" class="mb-3">
                                        <b>Datos personales</b>
                                        <ul>
                                            <li>Verificar nombre con reglas de ortografía, contemplando Mayúscula en la primera letra, y minúsculas en el resto con ACENTOS y puntuación.</li>
                                            <li>De la forma en que quede inscrito el nombre y apellido del Médico en este formulario, será bordada su Filipina y su Bata</li>
                                            <li>Se podrá colocar de 18 a 22 caracteres de acuerdo a su configuración por hospital (incluido espacios) en cada línea.</li>
                                        </ul>
                                        <p class="error-label" v-if="!checkIfCollaboratorsExist && dataUser.collaborator!=''" :key="checkIfCollaboratorsExist">El número de colaborador ingresado no existe.</p>
                                        <p class="error-label" v-if="checkIfCollaboratorsOrderExist" :key="checkIfCollaboratorsOrderExist">El colaborador ingresado ya realizó una orden</p>
                                    </b-col>
                                    <b-col v-show="dataUser.typeOrder" cols="12" class="mb-3 form-floating">
                                        <input oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" type = "number" maxlength = "6" class="form-control" v-model="dataUser.collaborator" @change="checkCollaborators" placeholder="# Colaborador" :class="{'required':  (empty && dataUser.collaborator=='')}" @focus="magic_flag = false" @blur="magic_flag = true" id="input-1">
                                        <label for="input-1"># Colaborador</label>
                                        <span class="required-label" :class="{'showlabel': (empty && dataUser.collaborator=='')}">Favor de ingresar datos</span>
                                    </b-col>
                                    <b-col v-show="dataUser.typeOrder" cols="12" class="mb-3 form-floating">
                                        <input type="text" class="form-control" :disabled="editInfo" :key="editInfo" v-model="dataUser.name" placeholder="Nombres(s)" :class="{'required1':  (empty && dataUser.name=='')}" id="input-1">
                                        <label for="input-1">Nombre(s)</label>
                                        <span class="error-label" v-if="(dataUser.name.length) > hospitalUser.max_chars">Excediste el máximo de {{ hospitalUser ? hospitalUser.max_chars : '' }} caracteres que se pueden utilizar en todos los campos. Actualmente tienes {{ dataUser.name.length }} caracteres.</span>
                                    </b-col>
                                    <p v-show="dataUser.area && dataUser.area.toLowerCase()=='bronce'">Nombre para referencia y registro de pedido; en la categoría bronce el personalizado no sera bordado</p>
                                    <b-col v-show="dataUser.typeOrder" cols="12" md="12" class="mb-3 form-floating">
                                        <b-form-input id="input-2" :disabled="editInfo" :key="editInfo" v-model="dataUser.lastname1" placeholder="Apellidos*"  :class="{'required1':  (empty && dataUser.lastname1=='')}" type="text"></b-form-input>    
                                        <label for="input-2">Apellidos</label>    
                                        <span class="error-label" v-if="(dataUser.lastname1.length) > hospitalUser.max_chars">Excediste el máximo de {{ hospitalUser ? hospitalUser.max_chars : '' }} caracteres que se pueden utilizar en todos los campos. Actualmente tienes {{ dataUser.lastname1.length }} caracteres.</span>
                                    </b-col>
                                    <b-col v-show="dataUser.typeOrder" cols="12" class="mb-3 form-floating">
                                        <b-form-input id="input-4" :disabled="editInfo" :key="editInfo" v-model="dataUser.speciality" placeholder="Especialidad" type="text" :class="{'required1':  (empty && dataUser.speciality=='')}"></b-form-input>
                                        <label for="input-4">Especialidad</label> 
                                        <span class="error-label" v-if="(dataUser.speciality.length) > this.specialityChars">Excediste el máximo de {{ specialityChars }} caracteres que se pueden utilizar en todos los campos. Actualmente tienes {{ dataUser.speciality.length }} caracteres.</span>
                                    </b-col>
                                    <b-col v-show="dataUser.typeOrder" cols="12" class="mb-3 form-floating">
                                        <b-form-input id="input-4" :disabled="editInfo" :key="editInfo" v-model="dataUser.speciality2" placeholder="Especialidad" type="text" :class="{'required1':  (empty && dataUser.speciality2=='')}"></b-form-input>
                                        <label for="input-4">Especialidad</label> 
                                        <span class="error-label" v-if="(dataUser.speciality2.length) > this.specialityChars">Excediste el máximo de {{ specialityChars }} caracteres que se pueden utilizar en todos los campos. Actualmente tienes {{ dataUser.speciality2.length }} caracteres.</span>
                                    </b-col>
                                    <b-col v-show="dataUser.typeOrder" cols="12" class="mb-3 form-floating">
                                        <single-select
                                            class="genderselect"
                                            :key="dataUser.gender+editInfo"
                                            :disabled="editInfo" 
                                            v-model="dataUser.gender"
                                            :options="['Hombre', 'Mujer']"
                                            placeholder=""
                                            :required="true"
                                            :label="'Selecciona tu género'"
                                        ></single-select>
                                    </b-col>
                                    <b-col v-if="checkIfCollaboratorsExist" cols="12" class="mb-3 btn-wrapper">
                                        <b-button v-if="editInfo" class="mb-3 mr-3" v-on:click="editInfoUser">Editar</b-button>
                                        <b-button v-if="!editInfo" class="mb-3 mr-3 btn-cancel" v-on:click="cancelEditInfoUser">Cancelar</b-button>
                                        <b-button v-if="!editInfo" class="mb-3 mr-3" v-on:click="saveEditInfoUser">Guardar</b-button>
                                    </b-col>
                                    <b-row class="row-no-space" v-for="(element, index) in arrayScrubs" :key="index+'_arrayScrubs'">
                                        <b-col v-if="element.model" cols="12" class="mb-3" style="position: relative;">
                                            <b>Talla Filipina</b>
                                            <img v-if="dataUser.gender && dataUser.gender.toLowerCase() === 'hombre'" v-on:mouseover="showModalSize" v-on:click="showModalSize" class="tooltip-icon" src="../../assets/imgs/icn_info.svg" alt="">
                                        </b-col>
                                        <b-col v-if="element.model" cols="12" md="6" class="mb-3">
                                            <fieldset :class="{'required':  (empty && (element.size=='' || element.size==null))}">
                                                <legend>Filipina {{element.model}}</legend>
                                                <single-select
                                                    v-model="element.size"
                                                    :options="getSizes(element.model)"
                                                    placeholder=""
                                                    :required="true"
                                                    :label="'Selecciona talla'"
                                                    :class="{'hide-label':  element.size}"
                                                ></single-select>
                                                <span class="required-label" :class="{'showlabel': (empty && (element.size==''||element.size==null))}">Favor de ingresar datos</span>
                                            </fieldset>
                                            
                                        </b-col>
                                    </b-row>
                                    <b-row class="row-no-space" v-for="(element, index) in arrayPants" :key="index+'_arrayPants'">
                                        <b-col v-if="element.model" cols="12" class="mb-3">
                                            <b>Talla Pantalón</b>
                                        </b-col>
                                        <b-col v-if="element.model" cols="12" md="6" class="mb-3">
                                            <fieldset :class="{'required':  (empty && (element.size=='' || element.size==null))}">
                                                <legend>Pantalón {{element.model}}</legend>
                                                    <single-select
                                                    v-model="element.size"
                                                    :options="getSizes(element.model)"
                                                    placeholder=""
                                                    :disabled="true"
                                                    :required="true"
                                                    :label="'Selecciona talla'"
                                                    :class="{'hide-label':  element.size}"
                                                ></single-select>
                                                <span class="required-label" :class="{'showlabel': (empty && (element.size==''||element.size ==null))}">Favor de ingresar datos</span>
                                            </fieldset>
                                        </b-col>
                                        <b-col md="12">
                                            <p class="note"><strong>NOTA.</strong> En caso de requerir una filipina o pantalón destallado, favor de contactar a su vinculador médico.</p>
                                        </b-col>
                                    </b-row>
                                    
                                    <b-row class="row-no-space" v-for="(element, index) in arrayCoat" :key="index+'_arrayCoat'">
                                        <b-col v-if="element.model" cols="12" class="mb-3">
                                            <b>Bata</b>
                                        </b-col>
                                        <b-col v-if="element.model" cols="12" md="6" class="mb-3">
                                            <fieldset :class="{'required':  (empty && (element.size=='' || element.size==null))}">
                                                <legend>Bata {{element.model}}</legend>
                                                    <single-select
                                                    v-model="element.size"
                                                    :options="getSizes(element.model)"
                                                    placeholder=""
                                                    :required="true"
                                                    :label="'Selecciona talla'"
                                                    :class="{'hide-label':  element.size}"
                                                ></single-select>
                                                <span class="required-label" :class="{'showlabel': (empty && (element.size==''||element.size ==null))}">Favor de ingresar datos</span>
                                            </fieldset>
                                        </b-col>
                                    </b-row>
                                    <b-row v-show="dataUser.area!='Bronce'" class="row-no-space" v-for="(element, index) in arrayJackets" :key="index+'_arrayJacket'">
                                        <b-col v-if="element.model" cols="12" class="mb-3">
                                            <b>Chamarra</b>
                                        </b-col>
                                        <b-col v-if="element.model" cols="12" md="6" class="mb-3">
                                            <fieldset :class="{'required':  (empty && (element.size=='' || element.size==null))}">
                                                <legend>Chamarra {{element.model}}</legend>
                                                    <single-select
                                                    v-model="element.size"
                                                    :options="getSizes(element.model)"
                                                    placeholder=""
                                                    :required="true"
                                                    :label="'Selecciona talla'"
                                                    :class="{'hide-label':  element.size}"
                                                ></single-select>
                                                <span class="required-label" :class="{'showlabel': (empty && (element.size==''||element.size ==null))}">Favor de ingresar datos</span>
                                            </fieldset>
                                        </b-col>
                                    </b-row>
                                    <b-col cols="12" class="mb-4">
                                        <b-form-checkbox
                                            id="checkbox-1"
                                            v-model="status"
                                            name="checkbox-1"
                                            class="mt-2"
                                            :class="{'required-check':  (empty && (status=='' || status==null))}"
                                            >
                                            Confirmo y acepto que la información proporcionada es correcta
                                        </b-form-checkbox>
                                    </b-col>
                                    <b-col md="10">
                                        <b-button v-on:click="submitOrder">Continuar</b-button>
                                    </b-col>
                                </b-row>
                            </b-tab>
                            <b-tab  v-if="role=='Admin'|| role=='Super'" title="ESTATUS DE ORDENES" :key="role">
                                <b-row>
                                    <b-col cols="12" class="mb-3">
                                        <h3>Estatus de ordenes</h3>
                                    </b-col>
                                    <b-col v-if="listCollaborators.length>0" md="6" cols="6" class="text-center mb-3">
                                        <div class="orders-count-wrapper">
                                            <h3>{{listCollaborators.length}}</h3>
                                            <p class="mb-0">Total de ordenes</p>
                                        </div>
                                    </b-col>
                                    <b-col v-if="listCollaborators.length>0" md="6" cols="6" class="text-center mb-3">
                                        <div class="orders-count-wrapper">
                                            <h3>{{listCollaborators.length - ordersUser.length}}</h3>
                                            <p class="mb-0">Ordenes pendientes por subir</p>
                                        </div>
                                    </b-col>
                                    <b-col md="4" cols="6" class="text-center mb-3">
                                        <div class="orders-count-wrapper">
                                            <h3>{{ordersUser.length}}</h3>
                                            <p class="mb-0">Ordenes generadas</p>
                                        </div>
                                    </b-col>
                                    <b-col md="4" cols="6" class="text-center mb-3">
                                        <div class="orders-count-wrapper">
                                            <h3>{{filteredOrdersCompleted.length}}</h3>
                                            <p class="mb-0">Ordenes entregadas</p>
                                        </div>
                                    </b-col>
                                    <b-col md="4" cols="6" class="text-center mb-3">
                                        <div class="orders-count-wrapper">
                                            <h3>{{ordersUser.length - filteredOrdersCompleted.length}}</h3>
                                            <p class="mb-0">Ordenes pendientes por entregar</p>
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-4 mb-5">
                                    <b-col class="mb-2" md="3" cols="6">
                                        <b-form-select id="status-filter" v-model="statusFilter" :options="statusOptions"></b-form-select>
                                    </b-col>    
                                    <b-col class="mb-2" md="9" cols="12">
                                        <b-form-input id="input-search" v-model="search" placeholder="Buscar # colaborador"  type="text"></b-form-input>    
                                    </b-col>   
                                </b-row>
                                <b-row> 
                                    <b-col cols="12">
                                        <table class="table table-orders b-table">
                                            <thead role="rowgroup">
                                                <tr>
                                                    <th>
                                                        No. de Colaborador
                                                    </th>
                                                    <th>
                                                        Estatus
                                                    </th>
                                                    <th>
                                                    </th>
                                                    <!-- <th>
                                                    </th> -->
                                                    <th>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody role="rowgroup">
                                                <tr role="row" v-for="(element) in filteredOrders" :key="'elementid_'+element.id">
                                                    <td class="td-number"> 
                                                        {{ element.collaborator_number }}
                                                    </td>
                                                    <td>
                                                        {{ element.status }}
                                                    </td>
                                                    <td class="td-btn-details">
                                                        <b-button v-on:click="showModalOrderDetails(element.id)" class="see-details-btn">Ver detalles</b-button>    
                                                    </td>
                                                    <!-- <td class="td-btn-details">
                                                        <b-button v-if="element.receipt" v-on:click="showModalImageReceipt(element.id)" class="see-details-btn">Ver imagen</b-button>    
                                                        <b-button v-else v-on:click="uploadImage(element.id)" class="see-details-btn">Agregar imagen</b-button>    
                                                    </td> -->
                                                    <td class="td-btn-details">
                                                        <b-button :disabled="element.status == 'Entregado'" v-on:click="completedStatusOrder(element.id)" class="see-details-btn">Confirmar entrega</b-button>    
                                                    </td>
                        
                                                </tr>
                                            </tbody>
                                        </table>
                                    </b-col>
                                </b-row>
                            </b-tab>
                        </b-tabs>
                    </b-container>
                    
                    <b-modal size="xl" id="modal-view-order" hide-footer centered>
                        <b-row>
                            <span class="title-modal-order">INFORMACIÓN DEL HOSPITAL</span>
                        </b-row>
                        <b-row>
                            <b-col cols="12" md="6" class="mb-3 text-left">
                                <b>Número de colaborador</b>
                                <p>{{ currentOrder ? currentOrder.collaborator_number : '' }}</p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" md="6" class="mb-3 text-left">
                                <b>Nombre</b>
                                <p>{{ currentOrder ? currentOrder.name : '' }} {{ currentOrder ? currentOrder.first_lastname : ''  }} {{ currentOrder ? currentOrder.second_lastname : '' }}</p>
                            </b-col>
                            <b-col cols="12" md="6" class="mb-3 text-left">
                                <b>Nombre del hospital</b>
                                <p>{{ currentOrder ? currentOrder.hospital : '' }}</p>
                            </b-col>
                        </b-row>
                        <b-row v-for="item in currentOrder ? currentOrder.ownItem : []" :key="'itemid_'+item.id">
                            <hr>
                            <b-col cols="12" md="12" class="text-left mb-3">
                                <span class="title-modal-order">{{ item.type }}</span>
                            </b-col>
                            <b-col cols="12" md="4" class="mb-3 text-left">
                                <b>Modelo</b>
                                <p>{{ item.model }}</p>
                            </b-col>
                            <b-col cols="12" md="4" class="mb-3 text-left">
                                <b>Color</b>
                                <p>{{ item.color }}</p>
                            </b-col>
                            <b-col cols="12" md="4" class="mb-3 text-left">
                                <b>Cantidad</b>
                                <p>{{ item.qty }}</p>
                            </b-col>
                            <b-col cols="12" md="4" class="mb-3 text-left">
                                <b>Talla</b>
                                <p>{{ item.size }}</p>
                            </b-col>
                            <b-col cols="12" md="4" class="mb-3 text-left">
                                <b>Género</b>
                                <p>{{ currentOrder ? currentOrder.gender : ''}}</p>
                            </b-col>
                        </b-row>
                    </b-modal>
                    <b-modal size="xl" id="modal-image" hide-footer centered>
                        <b-row class="text-center">
                            <span class="title-modal-order">Comprobante de recepcion de recibo</span>
                        </b-row>
                        <b-row>
                            <b-col cols="12" md="12" class="mb-3 text-center">
                                <img class="img-fluid img-comprobante" :src="currentOrder.receipt">
                            </b-col>
                        </b-row>
                    </b-modal>
                    <b-modal size="lg" id="modal-logo" class="modal-logo" no-close-on-backdrop no-close-on-esc hide-header-close hide-footer centered>
                        <p class="">Adjunta la evidencia de recepción</p>
                        <span>{{messageErrorModal}}</span>
                        <b-row>
                            <b-col cols="12" md="12" class="mb-3">

                                <!-- Selector de modo -->
                                <div class="d-flex mb-2" style="gap: 8px;">
                                <b-button
                                    size="sm"
                                    :variant="inputMode === 'file' ? 'primary' : 'outline-primary'"
                                    @click="setMode('file')"
                                >
                                    Subir archivo
                                </b-button>
                                <b-button
                                    size="sm"
                                    :variant="inputMode === 'camera' ? 'primary' : 'outline-primary'"
                                    @click="setMode('camera')"
                                >
                                    Tomar foto
                                </b-button>
                                </div>

                                <!-- Modo archivo -->
                                <div v-if="inputMode === 'file'">
                                <b-form-file
                                    accept="image/jpeg, image/png"
                                    v-model="receiptFile"
                                    :state="Boolean(receiptFile)"
                                    placeholder="Adjuntar la imagen"
                                    drop-placeholder="Suelta tu imagen aquí"
                                ></b-form-file>
                                </div>

                                <!-- Modo cámara -->
                                <div v-if="inputMode === 'camera'">

                                <!-- Input nativo oculto (funciona en HTTP/IP local) -->
                                <input
                                    type="file"
                                    accept="image/*"
                                    capture="environment"
                                    ref="cameraInput"
                                    style="display:none"
                                    @change="onCameraInputChange"
                                />

                                <!-- Video stream solo si es HTTPS/localhost y no se tomó foto aún -->
                                <div v-if="isHttps && !photoTaken">
                                    <video
                                    ref="cameraVideo"
                                    autoplay
                                    playsinline
                                    style="width:100%; border-radius:8px; background:#000;"
                                    ></video>
                                    <b-button class="mt-2" style="margin-left: auto; margin-right: auto; display: block;" @click="capturarFoto">
                                        <b-icon icon="camera" font-scale="2"></b-icon>
                                    </b-button>
                                </div>

                                <!-- Repetir foto (solo cuando ya se tomó) -->
                                <b-button
                                    v-if="photoTaken"
                                    size="sm"
                                    variant="outline-secondary"
                                    class="mb-2"
                                    @click="repetirFoto"
                                >
                                    Repetir foto
                                </b-button>

                                <canvas ref="cameraCanvas" style="display:none;"></canvas>
                                </div>

                                <!-- Preview -->
                                <img
                                v-if="previewUrl"
                                class="image-preview"
                                :src="previewUrl"
                                alt="Vista previa"
                                />

                            </b-col>
                            </b-row>

                        <b-button v-if="receiptFile" class="mr-4" variant="success" v-on:click="saveReceiptModal(idOrderReceipt)">Subir imagen</b-button>
                        <b-button variant="danger" v-on:click="cancelUploadImage()">Cancelar</b-button>
                    </b-modal>

                    <b-modal size="md" id="modal-size" hide-footer centered>
                        <b-row>
                            <b-col>
                                <h3>BARCO 0NE 2023</h3>
                                <b-table :items="items0115"></b-table>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <h3>BARCO ONE 2024</h3>
                                <b-table :items="itemsBOT195"></b-table>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <h3>BARCO WELLNESS 2024 (Diamantes/Honorificos)</h3>
                                <b-table :items="itemsBWT010"></b-table>
                            </b-col>
                        </b-row>
                        
                    </b-modal>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import SingleSelect from '../elements/SingleSelect.vue'
    import axios from 'axios'
    import qs from 'qs' 

    export default {
        components: {
            SingleSelect
        },
        beforeDestroy() {
          this.detenerCamara()
        },
        created() {
            //Get Session variables
            this.role = sessionStorage.getItem('role')
            var tempModel = [], tempUserInfo, tempCollaborators = []
            var datalist = sessionStorage.getItem('dataUser')
            tempUserInfo = JSON.parse(sessionStorage.getItem('hospital_user'))
            if(tempUserInfo)
                this.hospitalUser = tempUserInfo
            this.dataUser.hospital = this.hospitalUser ? this.hospitalUser.name : ''
            this.dataUser.id_hospital = this.hospitalUser ? this.hospitalUser.id : ''

            this.specialityChars = this.hospitalUser.max_chars
            
            
            var collaboratorsHospital = JSON.parse(sessionStorage.getItem('collaborators_user'))
            Object.keys(collaboratorsHospital).map((key) => [collaboratorsHospital[key]]).map(function(value) {
                tempCollaborators.push(value[0])
            })
            this.listCollaborators = tempCollaborators
            if (!this.data) {
                this.data = JSON.parse(datalist)
            }
            this.storageUser == datalist
            if (datalist) {
                this.dataUser = JSON.parse(datalist)
                this.arrayJackets = JSON.parse(sessionStorage.getItem('arrayJackets'))
                this.arrayScrubs = JSON.parse(sessionStorage.getItem('arrayScrubs'))
                this.arrayPants = JSON.parse(sessionStorage.getItem('arrayPants'))
                this.arrayCoat = JSON.parse(sessionStorage.getItem('arrayCoat'))
            }
    
            //Get hospital list

            var token = sessionStorage.getItem('api_token')
            var id_user = sessionStorage.getItem('id_user')
            
            this.getAllOrders()

            axios
            .post(
                process.env.VUE_APP_ROUTE_BACKEND_API+'orders_api.php',
                qs.stringify({ 
                    api_token: token, 
                    user_id: id_user,
                    all_model: 'YES',
                    option: 'get_catalogs',
                }),
            )
            .then((response) => {
                if (!response.data.error.code) {
                    Object.keys(response.data.models).map((key) => [response.data.models[key]]).map(function(value) {
                        tempModel.push(value[0])
                    })
                    this.optionsModels = tempModel
                }
            })
        },
        data() {
            return {
                role: '',
                statusFilter: 'all', 
                statusOptions: [
                    { value: 'all', text: 'Todos' },
                    { value: 'Entregado', text: 'Entregado' },
                    { value: 'No entregado', text: 'Sin entregar' }
                ],
                isHttps: location.protocol === 'https:' || location.hostname === 'localhost',
                inputMode: 'file',   // 'file' | 'camera'
                photoTaken: false,
                cameraStream: null,
                search: '',
                currentOrder: '',
                magic_flag:  true,
                // listTypeOrder: ['Médicos Productivos', 'Médico Diamante'],
                listTypeOrder: ['Médicos Productivos'],
                checkIfCollaboratorsExist: false,
                checkIfCollaboratorsOrderExist: false,
                idOrderReceipt: '',
                optionsModels: [],
                hospitalUser: {
                    image: '',
                    qty_filipinas: 0,
                    qty_pantalones: 0,
                    qty_chamarras: 0,
                    qty_batas: 0
                },
                ordersUser: [],
                editInfo: true,
                storageUser: '',
                index: 0,
                watchTracker: [],
                watchTrackerLogo: [],
                arrayJackets: [{
                    qty: 1,
                    model: '',
                    id: '',
                    size: '',
                    color: '',
                    logo: 'No',
                    embroid: '',
                    embroidText: '',
                    embroidPosition: '',
                    embroidFont: '',
                    embroidFontColor: '',
                    type: 'Chamarra',
                    save: false
                }],
                arrayCoat: [{
                    qty: 1,
                    model: '',
                    id: '',
                    size: '',
                    color: '',
                    logo: 'No',
                    embroid: '',
                    embroidText: '',
                    embroidPosition: '',
                    embroidFont: '',
                    embroidFontColor: '',
                    type: 'Bata',
                    save: false
                },{
                    qty: 1,
                    model: '',
                    id: '',
                    size: '',
                    color: '',
                    logo: 'No',
                    embroid: '',
                    embroidText: '',
                    embroidPosition: '',
                    embroidFont: '',
                    embroidFontColor: '',
                    type: 'Bata',
                    save: false
                }],
                arrayScrubs: [{
                    qty: 1,
                    model: '',
                    id: '',
                    size: '',
                    color: '',
                    logo: 'No',
                    embroid: '',
                    embroidText: '',
                    embroidPosition: '',
                    embroidFont: '',
                    embroidFontColor: '',
                    type: 'Filipina',
                    save: false 
                }],
                arrayPants: [{
                    qty: 1,
                    model: '',
                    id: '',
                    size: '',
                    color: '',
                    logo: 'No',
                    embroid: '',
                    embroidText: '',
                    embroidPosition: '',
                    embroidFont: '',
                    embroidFontColor: '',
                    type:'Pantalon',
                    save: false
                }],
                receiptFile: null,
                previewUrl: null,
                dataUser:{ 
                    typeOrder: '',
                    hospital: '',
                    id_hospital: '',
                    collaborator: '',
                    area: '',
                    name: '',
                    email:'',
                    phone: '',
                    lastname1: '',
                    speciality: '',
                    speciality2: '',
                    jobPosition: '',
                    gender: '',
                    abbreviation: ''
                },
                tempDataUser:{ 
                    name: '',
                    lastname1: '',
                    speciality: '',
                    speciality2: ''
                },
                listCollaborators: [],
                tempJackets: [],
                tempScrubs: [],
                tempPants: [],
                tempCoats: [],
                empty: false,
                status:'',
                statusMailing: '',
                sizes:['XXS','XS','S','M','L','XL','2XL'],
                coatsSizes: ['32','34','36','38','40','42','44'],
                specialityChars: '',
                items0115: [
                    {modelo:'0115', talla:'XS', hombres: '42', espalda:'51', largo:'74'},
                    {modelo:'0115', talla:'S', hombres: '47', espalda:'55', largo:'77'},
                    {modelo:'0115', talla:'M', hombres: '50', espalda:'59', largo:'77'},
                    {modelo:'0115', talla:'L', hombres: '55', espalda:'64', largo:'79'},
                    {modelo:'0115', talla:'XL', hombres: '60', espalda:'68', largo:'80'},
                    {modelo:'0115', talla:'2XL', hombres: '61', espalda:'69', largo:'80'}
                ],
                itemsBOT195: [
                    {modelo:'BOT195', talla:'XS', hombres: '41', espalda:'48', largo:'72'},
                    {modelo:'BOT195', talla:'S', hombres: '43', espalda:'51', largo:'73'},
                    {modelo:'BOT195', talla:'M', hombres: '46', espalda:'54', largo:'75'},
                    {modelo:'BOT195', talla:'L', hombres: '48', espalda:'60', largo:'76'},
                    {modelo:'BOT195', talla:'XL', hombres: '50', espalda:'64', largo:'77'},
                    {modelo:'BOT195', talla:'2XL', hombres: '58', espalda:'66', largo:'78'}
                ],
                itemsBWT010: [
                    {modelo:'BWT010', talla:'XS', hombres: '41', espalda:'48', largo:'74'},
                    {modelo:'BWT010', talla:'S', hombres: '43', espalda:'52', largo:'75'},
                    {modelo:'BWT010', talla:'M', hombres: '46', espalda:'56', largo:'76'},
                    {modelo:'BWT010', talla:'L', hombres: '48', espalda:'61', largo:'77'},
                    {modelo:'BWT010', talla:'XL', hombres: '51', espalda:'66', largo:'79'},
                    {modelo:'BWT010', talla:'2XL', hombres: '58', espalda:'67', largo:'80'},
                ],
                items: [],
                messageErrorModal: ''
            }
        }, 
        methods: {
            getAllOrders(){
                var token = sessionStorage.getItem('api_token')
                var id_user = sessionStorage.getItem('id_user')
                axios
                .post(
                    process.env.VUE_APP_ROUTE_BACKEND_API+'orders_api.php',
                    qs.stringify({ 
                        api_token: token, 
                        user_id: id_user,
                        option: 'get_orders',
                    }),
                )
                .then((response) => {
                    if (!response.data.error.code) {
                        var listOrders = []
                        Object.keys(response.data.orders).map((key) => [response.data.orders[key]]).map(function(value) {
                            listOrders.push(value[0])
                        })
                        this.ordersUser = listOrders
                    }
                })

            },
            submitOrder() {
                let valSize = true;
                if( this.dataUser.area == 'Bronce')
                {
                    if(this.checkEmpty(this.arrayScrubs[0].size) || this.checkEmpty(this.arrayPants[0].size))
                    {
                        valSize = false
                    }
                } else {
                    if(this.checkEmpty(this.arrayScrubs[0].size) || this.checkEmpty(this.arrayPants[0].size))
                    {
                        valSize = false
                    }
                }
                this.empty = true
                if( this.status &&
                    this.dataUser.hospital &&
                    this.dataUser.gender &&
                    (this.dataUser.name.length) <= this.hospitalUser.max_chars &&
                    (this.dataUser.lastname1.length) <= this.hospitalUser.max_chars &&
                    (this.dataUser.speciality.length) <= this.specialityChars &&
                    (this.dataUser.speciality2.length) <= this.specialityChars &&
                    valSize) {           
                    sessionStorage.setItem('dataUser',JSON.stringify(this.dataUser))
                    sessionStorage.setItem('arrayJackets',JSON.stringify(this.arrayJackets))
                    sessionStorage.setItem('arrayScrubs',JSON.stringify(this.arrayScrubs))
                    sessionStorage.setItem('arrayPants',JSON.stringify(this.arrayPants))
                    sessionStorage.setItem('arrayCoat',JSON.stringify(this.arrayCoat))
                    this.$router.push({ name: 'DetailsOrder', params: { data: this.dataUser}})
                }
            },
            showPreviewLogo(image){
                return image ? URL.createObjectURL(image) : ''
            },
            checkEmpty(value){
                return value==''|value==null|value==undefined
            },
            uploadImage(order_id){
                this.idOrderReceipt = order_id
                this.$bvModal.show('modal-logo')
            },
            cancelUploadImage(){
                this.detenerCamara()
                this.inputMode = 'file'
                this.photoTaken = false
                this.receiptFile = null
                this.idOrderReceipt = ''
                this.$bvModal.hide('modal-logo')
            },
            completedStatusOrder(o_id){
                var token = sessionStorage.getItem('api_token')
                var id_user = sessionStorage.getItem('id_user')

                let formData = new FormData()
                    formData.append('api_token', token)
                    formData.append('user_id', id_user)
                    formData.append('option', 'completed_status_order')
                    formData.append('o_id', o_id)
                    axios
                    .post(
                        process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        },
                    )
                    .then((response) => {
                        this.loading = true
                        console.log(response)
                        if (!response.data.error.code) {
                            this.getAllOrders()
                        } else {
                            this.loading = false
                            this.messageErrorModal = response.data.error.description
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            saveReceiptModal(o_id){
                var token = sessionStorage.getItem('api_token')
                var id_user = sessionStorage.getItem('id_user')

                let formData = new FormData()
                    formData.append('api_token', token)
                    formData.append('user_id', id_user)
                    formData.append('option', 'upload_proof_receipt')
                    formData.append('o_id', o_id)
                    formData.append('image', this.receiptFile)
                    axios
                    .post(
                        process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        },
                    )
                    .then((response) => {
                        this.loading = true
                        console.log(response)
                        if (!response.data.error.code) {
                            this.getAllOrders()
                            this.cancelUploadImage()
                        } else {
                            this.loading = false
                            this.messageErrorModal = response.data.error.description
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })

                        this.$bvModal.hide('modal-jacket-logo')
                        
            },
            showModalOrderDetails(order_id){
                // this.index = index
                this.currentOrder = this.ordersUser.find(element => element.id === order_id)
                this.$bvModal.show('modal-view-order')
            },
            showModalSize(){
                this.$bvModal.show('modal-size')
            },
            showModalImageReceipt(order_id){
                // this.index = index
                this.currentOrder = this.ordersUser.find(element => element.id === order_id)
                this.$bvModal.show('modal-image')
            },
            getSizes(index){
                if (index) {
                    return this.optionsModels.filter((x) => x.name == index).map(y => y.sharedSize)[0].map(z => z.name)
                } else {
                    return ''
                }
            },
            getModels(){
                if (this.dataUser.gender){
                    return
                }

                if (this.dataUser.gender == 'Hombre') {
                    this.arrayScrubs[0] =  this.optionsModels.filter((x) => x.type_id == '2' && (x.gender_id == '1' || x.gender_id == '3' || x.gender_id == '4'))
                    this.arrayPants[0] = this.optionsModels.filter((x) => x.type_id == '3' && (x.gender_id == '1' || x.gender_id == '3' || x.gender_id == '4'))
                    this.arrayCoat[0] = this.optionsModels.filter((x) => x.type_id == '5' && (x.gender_id == '1' || x.gender_id == '3' || x.gender_id == '4'))
                    this.arrayJackets[0]  = this.optionsModels.filter((x) => x.type_id == '4' && (x.gender_id == '1' || x.gender_id == '3' || x.gender_id == '4'))
                } else {
                    this.arrayScrubs[0] =  this.optionsModels.filter((x) => x.type_id == '2' && (x.gender_id == '2' || x.gender_id == '3' || x.gender_id == '5'))
                    this.arrayPants[0] = this.optionsModels.filter((x) => x.type_id == '3' && (x.gender_id == '2' || x.gender_id == '3' || x.gender_id == '5'))
                    this.arrayCoat[0] = this.optionsModels.filter((x) => x.type_id == '5' && (x.gender_id == '2' || x.gender_id == '3' || x.gender_id == '5'))
                    this.arrayJackets[0]  = this.optionsModels.filter((x) => x.type_id == '4' && (x.gender_id == '2' || x.gender_id == '3' || x.gender_id == '5'))
                }
            },
            checkCollaborators() {
                var a = this.listCollaborators.filter((x) =>
                    x.number.toString() === this.dataUser.collaborator && ((this.dataUser.typeOrder == 'Médicos Productivos' && (x.area.toLowerCase()=='platino' || x.area.toLowerCase()=='oro' || x.area.toLowerCase()=='plata' || x.area.toLowerCase()=='bronce')) || (this.dataUser.typeOrder == 'Médico Diamante' && (x.area.toLowerCase()=='diamante' || x.area.toLowerCase()=='honorifico')) || (this.dataUser.typeOrder == 'Torre de Consultorios' && x.area.toLowerCase()=='tdc' )))
                
                var a = this.listCollaborators.filter((x) => x.number.toString() === this.dataUser.collaborator )
                

                    if(a.length > 0){
                        var existingOrder =  this.ordersUser.filter((x) => x.collaborator_number.toString() == this.dataUser.collaborator)
                    
                        this.checkIfCollaboratorsExist = true
                        var areaCol = this.$R.prop('area', a[0])
                        if((existingOrder.length == 0 && areaCol!= 'bronce') || (existingOrder.length < 2 && areaCol == 'bronce')){
                            this.arrayJackets[0].model = ''
                            this.arrayScrubs[0].model = ''
                            this.arrayPants[0].model = ''
                            this.arrayCoat[0].model = ''
                            this.arrayCoat[1].model = ''
                            this.arrayJackets[0].color = ''
                            this.arrayScrubs[0].color = ''
                            this.arrayPants[0].color = ''
                            this.arrayCoat[0].color = ''
                            this.arrayCoat[1].color = ''
                            this.arrayJackets[0].size = ''
                            this.arrayScrubs[0].size = ''
                            this.arrayPants[0].size = ''
                            this.arrayCoat[0].size = ''
                            this.arrayCoat[1].size = ''
                            this.dataUser.name = this.$R.prop('name', a[0]) 
                            this.dataUser.lastname1 = this.$R.prop('first_lastname', a[0])+' '+this.$R.prop('second_lastname', a[0])
                            this.dataUser.gender = this.$R.prop('gender', a[0])
                            this.dataUser.speciality = this.$R.prop('specialty', a[0])
                            this.dataUser.speciality2 = this.$R.prop('specialty2', a[0])
                            this.dataUser.area = this.$R.prop('area', a[0])
                            this.tempJackets = a[0].items.filter((x) => x.type == 'Chamarra'),
                            this.tempScrubs = a[0].items.filter((x) => x.type == 'Filipina'),
                            this.tempPants = a[0].items.filter((x) => x.type == 'Pantalon'),
                            this.tempCoats =a[0].items.filter((x) => x.type == 'Bata')
                            this.specialityChars = this.$R.prop('max_chars', a[0])
                            this.specialityChars = (this.specialityChars && this.specialityChars>0) ? this.specialityChars : this.hospitalUser.max_chars

                            this.items = a[0].items

                            
                            if(this.dataUser.gender){
                                for(var i=0 ; i< this.tempJackets.length; i++){
                                    if(this.tempJackets[i].model){
                                        this.arrayJackets[i].model  = this.tempJackets[i].model.toString()
                                        this.arrayJackets[i].color  = this.tempJackets[i].color
                                    }
                                }
                                for( i=0 ; i< this.tempScrubs.length; i++){
                                    this.arrayScrubs[i].model  = this.tempScrubs[i].model.toString()
                                    this.arrayScrubs[i].color  = this.tempScrubs[i].color
                                }
                                for( i=0 ; i< this.tempPants.length; i++){
                                    this.arrayPants[i].model  = this.tempPants[i].model.toString()
                                    this.arrayPants[i].color  = this.tempPants[i].color
                                }
                                for( i=0 ; i< this.tempCoats.length; i++){
                                    this.arrayCoat[i].model  = this.tempCoats[i].model.toString()
                                    this.arrayCoat[i].color  = this.tempCoats[i].color
                                }   
                            } 
                            this.checkIfCollaboratorsExist = true
                            this.checkIfCollaboratorsOrderExist = false
                        } else{
                            this.checkIfCollaboratorsExist = true
                            this.checkIfCollaboratorsOrderExist = true
                            this.dataUser.name = ''
                            this.dataUser.lastname1 = ''
                            this.dataUser.gender = ''
                            this.dataUser.area = ''
                            this.dataUser.speciality = ''
                            this.dataUser.speciality2 = ''
                            this.dataUser.abbreviation = ''
                            this.arrayJackets[0].model = ''
                            this.arrayScrubs[0].model = ''
                            this.arrayPants[0].model = ''
                            this.arrayCoat[0].model = ''
                            this.arrayCoat[1].model = ''
                            this.arrayJackets[0].color = ''
                            this.arrayScrubs[0].color = ''
                            this.arrayPants[0].color = ''
                            this.arrayCoat[0].color = ''
                            this.arrayCoat[1].color = ''
                            this.arrayJackets[0].size = ''
                            this.arrayScrubs[0].size = ''
                            this.arrayPants[0].size = ''
                            this.arrayCoat[0].size = ''
                            this.arrayCoat[1].size = ''
                        }
                    } else {
                        this.dataUser.name = ''
                        this.dataUser.lastname1 = ''
                        this.dataUser.gender = ''
                        this.dataUser.area = ''
                        this.dataUser.speciality = ''
                        this.dataUser.speciality2 = ''
                        this.dataUser.abbreviation = ''
                        this.checkIfCollaboratorsExist = false
                        this.checkIfCollaboratorsOrderExist = false
                        this.arrayJackets[0].model = ''
                        this.arrayScrubs[0].model = ''
                        this.arrayPants[0].model = ''
                        this.arrayCoat[0].model = ''
                        this.arrayCoat[1].model = ''
                        this.arrayJackets[0].color = ''
                        this.arrayScrubs[0].color = ''
                        this.arrayPants[0].color = ''
                        this.arrayCoat[0].color = ''
                        this.arrayCoat[1].color = ''
                        this.arrayJackets[0].size = ''
                        this.arrayScrubs[0].size = ''
                        this.arrayPants[0].size = ''
                        this.arrayCoat[0].size = ''
                        this.arrayCoat[1].size = ''
                    }
            },
            isNumber: function(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault()
                } else {
                    return true;
                }
            },
            editInfoUser(){
                this.tempDataUser.name = this.dataUser.name
                this.tempDataUser.lastname1 = this.dataUser.lastname1
                this.tempDataUser.speciality = this.dataUser.speciality
                this.tempDataUser.speciality2 = this.dataUser.speciality2
                this.editInfo = false
            }, 
            saveEditInfoUser(){
                this.editInfo = true
            }, 
            cancelEditInfoUser(){
                this.dataUser.name = this.tempDataUser.name
                this.dataUser.lastname1 = this.tempDataUser.lastname1
                this.dataUser.speciality = this.tempDataUser.speciality
                this.dataUser.speciality2 = this.tempDataUser.speciality2
                this.editInfo = true

            },
            // Cambiar entre modo archivo y cámara
            setMode(mode) {
                this.inputMode = mode
                this.photoTaken = false
                this.receiptFile = null
                this.previewUrl = null

                // Detener cámara si se cambia a archivo
                if (mode !== 'camera') {
                    this.detenerCamara()
                } else {
                    this.$nextTick(() => {
                    this.iniciarCamara()
                    })
                }
            },

            // Iniciar stream de la cámara
            async iniciarCamara() {
                // Si no es HTTPS ni localhost, usar input nativo (IP local, HTTP)
                if (location.protocol !== 'https:' && location.hostname !== 'localhost') {
                    this.$nextTick(() => {
                    this.$refs.cameraInput.click() // abre la cámara nativa del teléfono
                    })
                    return
                }

                // Desktop o HTTPS: usar getUserMedia como antes
                try {
                    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                    this.$refs.cameraInput.click()
                    return
                    }
                    this.cameraStream = await navigator.mediaDevices.getUserMedia({
                    video: { facingMode: 'environment' }
                    })
                    this.$refs.cameraVideo.srcObject = this.cameraStream
                } catch (err) {
                    console.error('Camera error:', err)
                    this.$refs.cameraInput.click() // fallback si falla
                }
            },

            // Detener stream
            detenerCamara() {
                if (this.cameraStream) {
                    this.cameraStream.getTracks().forEach(track => track.stop())
                    this.cameraStream = null
                }
            },

            onCameraInputChange(event) {
                const file = event.target.files[0]
                if (!file) return

                this.receiptFile = file
                this.previewUrl = URL.createObjectURL(file)
                this.photoTaken = true
            },

            // Capturar foto del video
            capturarFoto() {
                const video = this.$refs.cameraVideo
                const canvas = this.$refs.cameraCanvas

                canvas.width = video.videoWidth
                canvas.height = video.videoHeight
                canvas.getContext('2d').drawImage(video, 0, 0)

                // Preview
                this.previewUrl = canvas.toDataURL('image/jpeg')

                // Convertir a File (igual que si viniera del b-form-file)
                canvas.toBlob((blob) => {
                    this.receiptFile = new File([blob], 'foto_capturada.jpg', { type: 'image/jpeg' })
                }, 'image/jpeg', 0.9)

                this.photoTaken = true
                this.detenerCamara() // liberar cámara tras capturar
            },

            // Volver a intentar la foto
            repetirFoto() {
                this.photoTaken = false
                this.receiptFile = null
                this.previewUrl = null
                this.$nextTick(() => {
                    this.iniciarCamara()
                })
            },
        },
        computed: {
            lengthCharacters: function(){
               return this.dataUser.name.length + this.dataUser.lastname1.length + this.dataUser.abbreviation.length + this.dataUser.speciality.length + this.dataUser.speciality2.length
            },
            filteredOrders() {
                let result = this.ordersUser;

                // Filtro por estatus
                if (this.statusFilter === 'Entregado') {
                    result = result.filter(element => element.status === 'Entregado');
                } else if (this.statusFilter === 'No entregado') {
                    result = result.filter(element => element.status !== 'Entregado');
                }
                // si statusFilter === 'all', no se filtra por estatus

                // Filtro por búsqueda
                if (this.search && this.search.trim() !== '') {
                    const searchTerm = this.search.trim().toLowerCase();
                    result = result.filter(element =>
                        String(element.collaborator_number).toLowerCase().includes(searchTerm)
                    );
                }

                return result;
            },
            filteredOrdersCompleted() {
                return this.ordersUser.filter(element => 
                    String(element.status).toLowerCase().includes('entregado')
                    );
            }
        },
        watch: {
            receiptFile(newFile) {
                // Libera el URL anterior para evitar memory leaks
                if (this.previewUrl) {
                URL.revokeObjectURL(this.previewUrl);
                this.previewUrl = null;
                }

                if (newFile) {
                this.previewUrl = URL.createObjectURL(newFile);
                }
            },
            arrayScrubs: {
                handler:function() {
                    if(this.arrayScrubs[0].size){
                        this.arrayPants[0].size = this.arrayScrubs[0].size
                    } else {
                        this.arrayPants[0].size = ''
                    }
                },
                deep:true
            },
            'dataUser.gender': {
                handler:function() {
                    if(this.dataUser.gender){
                        this.tempJackets = this.items.filter((x) => x.type == 'Chamarra' && x.gender == this.dataUser.gender),
                        this.tempScrubs = this.items.filter((x) => x.type == 'Filipina' && x.gender == this.dataUser.gender),
                        this.tempPants = this.items.filter((x) => x.type == 'Pantalon' && x.gender == this.dataUser.gender),
                        this.tempCoats = this.items.filter((x) => x.type == 'Bata' && x.gender == this.dataUser.gender)

                        
                        for(var i=0 ; i< this.tempJackets.length; i++){
                            if(this.tempJackets[i].model){
                                this.arrayJackets[i].model  = this.tempJackets[i].model.toString()
                                this.arrayJackets[i].color  = this.tempJackets[i].color
                            }
                        }
                        for( i=0 ; i< this.tempScrubs.length; i++){
                            this.arrayScrubs[i].model  = this.tempScrubs[i].model.toString()
                            this.arrayScrubs[i].color  = this.tempScrubs[i].color
                        }
                        for( i=0 ; i< this.tempPants.length; i++){
                            this.arrayPants[i].model  = this.tempPants[i].model.toString()
                            this.arrayPants[i].color  = this.tempPants[i].color
                        }
                        for( i=0 ; i< this.tempCoats.length; i++){
                            this.arrayCoat[i].model  = this.tempCoats[i].model.toString()
                            this.arrayCoat[i].color  = this.tempCoats[i].color
                        }   
                    } else {
                        for(var i=0 ; i< this.arrayJackets.length; i++){
                            this.arrayJackets[i].model = ''
                            this.arrayJackets[i].color  = ''
                            this.arrayJackets[i].size  = ''
                            
                        }
                        for( i=0 ; i< this.arrayScrubs.length; i++){
                            this.arrayScrubs[i].model  = ''
                            this.arrayScrubs[i].color  = ''
                            this.arrayScrubs[i].size  = ''
                        }
                        for( i=0 ; i< this.arrayPants.length; i++){
                            this.arrayPants[i].model  = ''
                            this.arrayPants[i].color  = ''
                            this.arrayPants[i].size  = ''
                        }
                        for( i=0 ; i< this.arrayCoat.length; i++){
                            this.arrayCoat[i].model  = ''
                            this.arrayCoat[i].color  = ''
                            this.arrayCoat[i].size  = ''
                        } 
                    }
                }
            },
            'dataUser.typeOrder': {
                handler:function() {
                    this.dataUser.collaborator = ''
                    this.dataUser.name = ''
                    this.dataUser.area = ''
                    this.dataUser.lastname1 = ''
                    this.dataUser.gender = ''
                    this.dataUser.speciality = ''
                    this.dataUser.speciality2 = ''
                    this.dataUser.abbreviation = ''
                    this.arrayJackets[0].size = ''
                    this.arrayScrubs[0].size = ''
                    this.arrayPants[0].size = ''
                    this.arrayCoat[0].size = ''
                    this.arrayCoat[1].size = ''

                }
                        
            }
        }
    }
</script>

<style scoped>
.order-container{
    padding: 70px 12% 70px 7%;
}
.full-height{
    height: 100vh;
}
.fixed-div{
    position: fixed;
    /* background: #5A6FBE; */
    background-image: url('../../assets/imgs/DDM26-01.jpeg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom;
    height: 100%;
    max-height: 100vh;
}
.logo-hospital{
    background-color: #fff;
    text-align: center;
    align-self: end;
    padding: 10%;
    min-height: 100px;
}
.row-no-space{
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
}
.mr-4{
    margin-right: 15px;
}
h1{
    font-weight: bold;
    text-align: center;
}
h3{
    font-weight: bold;
    font-size: 25px;
}
span{
    font-size: 16px;
    color: #5965B1;
}
p{
   font-size: 14px; 
}
b{
    color: #24A7DF;
}
.note{
    font-size: 14px;
    color: #5965B1;
}
.btn,
.btn:focus,
.btn:hover{
    background: #24A7DF;
    border: none;
    width: 100%;
}
.btn:focus,
.btn:hover{
    color: #FFF !important;
}
.btn-group{
    width: 100%;
}
legend {
    color: rgba(89, 101, 177, 1);
    float: none;
    width: fit-content;
    padding: 0;
    margin-bottom: 0.5rem;
    margin-left: 1rem;
    font-size: 15px;
    line-height: inherit;
    margin-bottom: 0;
}
fieldset{
    border: 1px solid #5965B1;
    border-radius: 5px;
    position: relative;
}
fieldset label{
    position: absolute;
    left: 1rem;
    bottom: 25%;
    z-index: 2;
    font-size: 20px;
    color: rgba(89, 101, 177, 0.4);
}
fieldset label.show{
    color: rgba(89, 101, 177, 1) !important;
}
.tooltip-icon{
    position: absolute;
    top: 0px;
    left: 95%;
    width: 30px;
}
.abbreviation{
    position: absolute;
    top: 1.6rem;
    margin-left: 0.76rem;
    color: #212529;
}
.field-name{
    padding-left: 50px !important;
}
.size-container{
    position: relative;
}

.size-container label{
    position: absolute;
    left: 1rem;
    bottom: 25%;
    z-index: 2;
    font-size: 20px;
    color: rgba(89, 101, 177, 0.4);
}
.size-container.show label{
    color: rgba(89, 101, 177, 1) !important;
}
.size-container.coat-container label{
    left: calc(2rem - 2px);
    color: rgba(89, 101, 177, 0.4);
}
.size-container.coat-container.show label{
    color: rgba(89, 101, 177, 1) !important;
}
.qty-container{
    position: relative;
    width: 100%;
    border:1px solid #5965B1 !important;
    border-radius: 5px;
    padding: 0.4rem 0.5rem;
    height: 100%;
}
.qty-container.required{
    border-color: #D85067 !important;
}
.wrapper-gender-check{
    border:1px solid #5965B1 !important;
    border-radius: 5px;
    height: 45px;
    margin: 0 10px;
    padding-top: 10px;
    width: calc(50% - 20px);
}
.radioBtn-border{
    border: 1px solid rgba(89, 101, 177, 1);
}
.embroid-container{
    border-radius: 5px;
    width: 100%;
    display: -webkit-flex;
    display: flex;
}
.embroid-container label{
    margin-right: 20px;
    margin-left: 1.1rem;
    margin-top: 0.6rem;
    z-index: 2;
    font-size: 20px;
    color: rgba(89, 101, 177, 0.4);
}
.embroid-container.show label{
    color: rgba(89, 101, 177,1) !important;
}
.embroid-container .radioBtn{
    width: inherit;
}
.required-label{
    color: #D85067;
    font-size: 10px;
    position: absolute;
    display: none;
}
.error-label{
    color: #D85067;
}
.form-floating .error-label,
ul li{
    font-size: 14px;}
.showlabel.required-label{
    display: block;
}
.wrapper-social-media-form{
    position: absolute;
    bottom: 10%;
}
.wrapper-social-media-form a{
    margin: 12px;
}

.orders-count-wrapper{
    padding: 20px 15px; 
    border: 1px solid #000; 
    border-radius: 15px;
    height: 100%;
    width: 100%;
}

.td-number{
    width: 35%;
}

.td-btn-details{
    width: 120px;
}
.text-left{
    text-align: left;
}
.btn-wrapper {
    display: flex;
}
.btn-wrapper .btn{
    width: 40%;
    max-width: 300px;
    margin-right: 5%;
}
.btn-wrapper .btn-cancel{
    background: rgba(36, 167, 223, 0.1);
    color: #24A7DF;
}
.img-comprobante{
    max-width: 500px; 
    margin-left: auto;
}
@media (max-width: 1600px) {
    .order-container{
        padding: 70px 10% 70px 6%;
    }
    h3{
        font-size: 20px;
    }
    .form-floating .error-label,
    ul li,
    p{
        font-size: 12px; 
    }
    .note{
        font-size: 11px;
    }
    legend {
        font-size: 12px;
    }
    .logo{
        width: 70%;
    }
    .qty-container{
        height: 45px;
    }
    .size-container label{
        bottom: 25%;
        font-size: 14px;
    }
    .size-container.coat-container label{
        left: 2rem;
        font-size: 14px;
    }
    .embroid-container label,
    fieldset label{
        font-size: 14px;
    }
    .wrapper-social-media-form{
        margin-top: 50px;
    }
    .wrapper-social-media-form a{
        margin: 10px;
    }
    .wrapper-social-media-form img{
        width: 40px;
    }
    .abbreviation{
        position: absolute;
        top: 1.17rem;
        margin-left: 0.9rem;
        color: #212529;
    }
}



.wrapper-details{
    background: rgba(247, 249, 255, 0.5);
    padding: 18px;
}
.wrapper-details p{
    color: #112357;
    margin-bottom: 0px;
    font-size: 16px !important;
}
.wrapper-details span{
    color: #112357;
    margin-bottom: 0px;
    font-weight: 500;
}
.wrapper-details .title{
    color: #5965B1;
    font-weight: 600 !important;
    font-size: 16px;
    margin-bottom: 0px;
}
.img-modal{
    border: 1px solid #5965B1;
    width: 100%;
    border-radius: 5px;
}
.img-back-modal{
    opacity: 0.5 !important;
}
.modal-body p{
    text-align: center;
    color: #5965B1;
    font-weight: bold;
    font-size: 19px;
}
.modal-body .btn{
    margin-top: 20px;
    width: 100px;
}
.modal-body .btn-primary {
    background: #112357;
    color: #FFF;
    width: 50%;
}
.modal-body .btn-danger {
    background: #dc3545;
    color: #FFF;
    width: 40%;
}
.modal-body .btn-success {
    background: #28a745;
    color: #FFF;
    width: 40%;
}
.modal-body .btn-outline-primary {
    background: transparent;
    border: 2px solid #112357;
    color: #112357;
    width: 50%;
}
.modal-body .btn-outline-secondary {
    color: #FFF;
}
#modal-view-order p{
    color: #000;
    font-weight: normal;
    text-align: left;
    display: block;
    width: 100%;
    height: calc(1.5em + 1.25rem + 2px);
    padding: 0.625rem 0.75rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #cad1d7;
    border-radius: 0.375rem;
    font-size: 0.875rem;
}
#modal-view-order b{
    color: #525f7f;
    font-size: 0.875rem;
    font-weight: 600;
}
#modal-view-order .title-modal-order{
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #8898aa !important;
    text-align: left;
    margin-left: -3%;
    margin-bottom: 20px;
}
.image-preview{
    /* position: absolute; */
    top: 2.5%;
    left: calc(2.5% + 15px);
    max-height: calc(95% - 1.5em - 0.75rem - 2px);
    max-width: 90%;
}
.see-details-btn{
    color: #24A7DF;
    font-size: 15px;
    background: rgba(36, 167, 223, 0.1);
}
.powered-wrapper{
    width: fit-content;
    margin-left: auto;
}
.logo-domik{
    max-width: 200px;
}
.diamedico{
    display: none;
}

#status-filter{
    height: 100%;
}

@media (max-width: 1600px) {
    .see-details-btn{
        font-size: 13px;
    }
}

@media (max-width: 991px) {

    .fixed-div{
        position: relative;
        padding: 0;
        width: 100%;
        overflow-x: hidden;
        max-height: 100%;
    }   
    .diamedico{
        display: block;
        width: 100%;
    }
    .logo-hospital{
        margin-top: 50px;
    }
    .full-height{
        height: fit-content;
    }

    .wrapper-social-media-form{
        position: relative;
        bottom: 10%;
    }

    .btn-wrapper .btn{
        width: 100%;
        max-width: 100%;
        margin-right: 0;
    }
}

@media (max-width: 768px) {
    .order-container{
        padding: 50px 5% 50px 5%;
    }
    .wrapper-social-media-form{
        margin-top: 70px;
    }
    .img-comprobante{
        max-width: 100%; 
        margin-left: auto;
    }
}
</style>
